/* eslint-disable no-unreachable */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import * as React from "react";
import "./switch.css";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import orderImg from "../../icons/order.png";
import moment from "moment";
import { useEffect, useState, useRef } from "react";
// import orderDetail from "./orderCompleteDetail";
import searchicon_black from "../../icons/searchicon_black.png";
import style from "../../components/Search&Options/Search&Options.module.css";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import ThemeMaker from "../../components/thememaker";
import { Paginated } from "../../components/Paginated";
import * as XLSX from 'xlsx';
import { Button } from "antd";
import { Modal as AntModal } from "antd";
import { Tag } from "antd";
// import InputTemplate from "../../components/Search&Options/InputTemplate";

const customerOrder = () => {
  const decoded: any = tokenDecode();
  const [orderList, setOrderList] = useState([]);
  const [sellerList, setSellerList] = useState([]);
  const [billings, setBillings]: any = useState([]);
  const [items, setItems]: any = useState([]);
  const [payment, setPayment]: any = useState([]);
  const [quote, setQuote]: any = useState([]);
  const [allorders, setallorders] = useState([])
  const [isLoading, setIsLoading] = useState(true);
  const { apiEndpoint } = config;
  const [toggle, setToggle] = useState(false);
  const rawData = {
    provider_id: "",
  };
  const [orderDetail, setorderDetail]: any = useState([]);
  const [_orderDetail, _setorderDetail]: any = useState({
    billing_address: "",
    contact_number: "",
    created_at: "",
    email: "",
    id: "",
    name: "",
    order_id: "",
    order_state: "",
    provider_id: "",
    shipping_address: "",
    status: "",
    total_price: 0,
  });
  const [updateOrder_, setUpdateOrder_]: any = useState({
    order_id: "",
    tracking_url: "",
    order_state: ""
  })
  const [searchData, setSearchData]: any = useState(rawData);
  const [sorderList, setSorderList] = useState([]);

  const [valuename, setValuename] = useState("");
  const [valueid, setValueid] = useState("");
  const [valueemail, setValueemail] = useState("");
  const [valuecontact, setValuecontact] = useState("");
  const [valuestatus, setValuestatus] = useState("");
  const [valueamount, setValueamount] = useState("");
  const [valuedate, setValuedate] = useState("");
  const { data } = decoded;
  const {
    permission: { category, order, product, role, seller, tax, user },
  } = data;

  // ---- COMBINED FILTER STATE (Order ID + Payment Status + Date) ----
  const [filters, setFilters] = useState({
    order_id: "",
    payment_type: "",
    created_at: "",
  });

  // Single function that always sends ALL currently active filters together
  const applyFilters = async (updatedFilters: typeof filters) => {
    const hasAnyFilter = Object.values(updatedFilters).some((v) => v && v.trim() !== "");

    // No filters active at all → show full unfiltered list
    if (!hasAnyFilter) {
      getSellerList();
      return;
    }

    const payload: any = {};
    if (updatedFilters.order_id.trim()) payload.order_id = updatedFilters.order_id.trim();
    if (updatedFilters.payment_type.trim()) payload.payment_type = updatedFilters.payment_type.trim();
    if (updatedFilters.created_at.trim()) payload.created_at = updatedFilters.created_at.trim();

    try {
      setIsLoading(true);
      setToggle(true);
      const { data } = await axios({
        url: `${apiEndpoint}/snp/orders/filter-active-order-list`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: payload,
      });

      if (data && (data.status === true || data.status === 200) && Array.isArray(data.orders) && data.orders.length > 0) {
        setSellerList(data.orders);
        setOrderList(data.orders);
      } else {
        setSellerList([]);
        setOrderList([]);
      }
    } catch (error) {
      console.log("error", error);
      setSellerList([]);
      setOrderList([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Individual field handlers — each updates its own value AND merges into the shared filter state
  const handleOrderIdChange = (e: any) => {
    const value = e.target.value;
    setValueid(value);
    const updated = { ...filters, order_id: value };
    setFilters(updated);
    applyFilters(updated);
  };

  const handlePaymentStatusChange = (e: any) => {
    const value = e.target.value;
    setValuestatus(value);
    const updated = { ...filters, payment_type: value };
    setFilters(updated);
    applyFilters(updated);
  };

  const handleDateChange = (e: any) => {
    const value = e.target.value;
    setValuedate(value);
    const updated = { ...filters, created_at: value };
    setFilters(updated);
    applyFilters(updated);
  };

  const handleClearDate = () => {
    setValuedate("");
    const updated = { ...filters, created_at: "" };
    setFilters(updated);
    applyFilters(updated);
  };

  const fetchSellerList = async () => {
    setIsLoading(true);
    let parentId = decoded?.data?.user?.parent_id;
    let SellerId = decoded?.data?.user?.seller_id;
    let payload;
    if (parentId > 1) {
      payload = { seller_id: parentId }

    } else {
      payload = { seller_id: SellerId }

    }
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getsellerorderlistnew`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: payload,
      });
      setOrderList(data.data);

      if (data.status === 200) {
        setOrderList(data.data);

        setIsLoading(false);
      }
    } catch (error) {
      console.log("error", error);

      setIsLoading(false);
    }
  };
  const getorderDetails = async (order_id: any) => {
    setIsLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getsellerorderhh`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
        },
        data: {
          order_id
        }
      });
      // console.log("order detail ->------   ", data);
      if (data.status === 200) {
        setIsLoading(false);
        setorderDetail(data.products);
        let totalP = 0
        data.products.forEach((item: any) => {
          totalP += parseFloat(item?.price)
        })
        setUpdateOrder_({
          ...updateOrder_,
          order_id: data.data[0]?.order_id,
          tracking_url: data.data[0]?.tracking_url,
          order_state: data.data[0]?.order_state
        })
        _setorderDetail({ ..._orderDetail, ...data.data[0], total_price: totalP, billing_address: JSON.parse(data.data[0]?.billing), shipping_address: JSON.parse(data.data[0]?.fulfillments) });
      }
    } catch (error) {
      console.log("error", error);
      setIsLoading(false);
    }
  }
  const updateOrder = async (order_id: any) => {
    try {

      const { data } = await axios({
        url: `${apiEndpoint}/updateorderstatus`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
        },
        data: updateOrder_
      });
      // console.log(data, "datadata");

      if (data.message === "flag1") {
        toast.success("Order updated !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        // fetchSellerList();
      } else {
        toast.error("Something went wrong !", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

    } catch (error) {
      console.log("update error", error);
      toast.error("404 error !", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      // window.location.reload();

    }
  }
  const getSellerList = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/orders/get-active-order-list`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      if (data.status == true) {
        setSellerList(data?.orders || []);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };
  const inputHandler = async (e: any) => {
    setValuename("");
    setValueid("");
    setValueemail("");
    setValuecontact("");
    setValuestatus("");
    setValueamount("");
    setValuedate("");
    var optionvalue = e.target.value;
    if (optionvalue) {
      try {
        setSearchData({ ...searchData, [e.target.name]: e.target.value });
        const { data } = await axios({
          url: `${apiEndpoint}/filterbyseller`,
          method: "POST",
          headers: {
            "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: {
            provider_id: optionvalue,
          },
        });

        if (data.status === 200) {
          // console.log(data);
          setOrderList(data.data);
          setSorderList(data.data);
          setToggle(true);
        }
      } catch (error) {
        console.log("error", error);
      }
    } else {
      setOrderList(sorderList);
    }
  };
  const inputeHandler = async (e: any) => {
    const optionvalue = e.target.value;
    setValuename(optionvalue);
    if (optionvalue) {
      try {
        const { provider_id } = searchData;
        setToggle(true);
        setSearchData({ ...searchData, [e.target.name]: e.target.value });
        const { data } = await axios({
          url: `${apiEndpoint}/filterbysellerorder`,
          method: "POST",
          headers: {
            "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: {
            provider_id: { searchData },
            name: optionvalue,
            order_status: "open-order"
          },
        });

        // console.log({
        //   data: {
        //     provider_id: { searchData },
        //     name: optionvalue,
        //   },
        // });

        if (data.status === 200) {
          // console.log(data);
          setOrderList(data.response);
        }
      } catch (error) {
        console.log("error", error);
      }
    } else {
      inputHandler(e);
    }
  };
  const inputeeHandler = async (e: any) => {
    const optionvalue = e.target.value;
    setValuename(optionvalue);
    if (optionvalue) {
      try {
        setToggle(true);
        setSearchData({ ...searchData, [e.target.name]: e.target.value });
        const { data } = await axios({
          url: `${apiEndpoint}/filterordersellerlogin`,
          method: "POST",
          headers: {
            "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
          },
          data: {
            name: optionvalue,
            order_status: "open-order"
          },
        });

        if (data.status === 200) {
          // console.log(data.response);
          setOrderList(data.response);
        }
      } catch (error) {
        console.log("error", error);
      }
    } else {
      // fetchSellerList();
    }
  };

  const COLUMNS = [
    {
      Header: "Serial No.",
      accessor: (row: any, count: any) => {
        return <>{count + 1}</>;
      },
      disableFilters: true,
      sticky: "left"
    },
    {
      Header: "Order ID",
      accessor: (a: any) => (
        <span className="font-weight-bold" style={{ color: "#0F172A" }}>
          {a?.order_id || "-"}
        </span>
      ),
      sticky: "left"
    },
    {
      Header: "BAP ID",
      accessor: (a: any) => (
        <span style={{ color: "#475569", fontWeight: 500, fontSize: "13px" }}>
          {a?.bap_id || "-"}
        </span>
      ),
      sticky: "left"
    },
    {
      Header: "Order Status",
      accessor: (a: any) => {
        const state = (a?.order_state || a?.status || "CREATED").toUpperCase();
        return (
          <span
            className="badge"
            style={{
              backgroundColor: "#DCFCE7",
              color: "#15803D",
              border: "1px solid #BBF7D0",
              borderRadius: "20px",
              padding: "5px 12px",
              fontWeight: 600,
              fontSize: "12px",
            }}
          >
            {state}
          </span>
        );
      },
      sticky: "left",
    },
    {
      Header: "Item",
      accessor: (a: any) => a?.item_count ?? "-",
      sticky: "left",
    },
    {
      Header: "Customer Name",
      accessor: (a: any) => (
        <span style={{ color: "#334155" }}>
          {a?.name || "-"}
        </span>
      ),
      sticky: "left"
    },
    {
      Header: "Total (In Rs)",
      accessor: (a: any) => (
        <span className="font-weight-bold" style={{ color: "#F97316" }}>
          ₹{a?.order_total ?? 0}
        </span>
      ),
      sticky: "left"
    },
    {
      Header: "Payment Status",
      accessor: (row: any) => {
        const isPaid = (row?.payment_status || row?.status || "").toUpperCase() === "PAID" || row.payment_type === "ON-ORDER";
        return (
          <span
            className="badge"
            style={{
              backgroundColor: isPaid ? "#DCFCE7" : "#FEF3C7",
              color: isPaid ? "#15803D" : "#B45309",
              border: `1px solid ${isPaid ? "#BBF7D0" : "#FDE68A"}`,
              borderRadius: "20px",
              padding: "5px 12px",
              fontWeight: 600,
              fontSize: "12px",
            }}
          >
            {isPaid ? "PAID" : "COD / UNPAID"}
          </span>
        );
      },
      sticky: "left"
    },
    {
      Header: "Created Date",
      accessor: (a: any) => a?.created_at ? moment(a.created_at).format("DD MMM YYYY, hh:mm A") : "-",
      sticky: "left"
    },
    {
      Header: "Action",
      accessor: (item: any) => {
        return (
          <Link to={`/orderCompleteDetail/${item?.order_id}`}>
            <span
              className="btn btn-sm text-white font-weight-bold"
              style={{
                backgroundColor: "#F97316",
                borderColor: "#F97316",
                borderRadius: "8px",
                padding: "5px 14px",
                fontSize: "12px",
                whiteSpace: "nowrap"
              }}
            >
              Get Order Details
            </span>
          </Link>
        );
      },
      sticky: "left"
    },
  ];

  const exportorders = async () => {
    let payload;
    const userArray = decoded?.data?.user || decoded?.user || [];
    const userObj = Array.isArray(userArray) ? userArray[0] : (userArray || {});
    let sellerId = userObj?.seller_id;
    if (sellerId == 1 || sellerId > 1) {
      payload = sellerId;
    }

    if (sellerId == 0 || !sellerId) {
      payload = userObj?.parent_id || "1";
    }

    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getallstatusorder`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`
        },
        data: {
          seller_id: payload,
        }
      });
      if (data?.status === 200 || data?.status === true) {
        const orderList = data?.orders || data?.data || [];
        setallorders(orderList);
        return orderList;
      }
      return [];
    } catch (error) {
      console.log("error", error);
      return [];
    }
  };

  const exportToExcel = (orders: any) => {
    const orderList = Array.isArray(orders) ? orders : [];
    if (orderList.length === 0) {
      toast.info("No orders available to export.");
      return;
    }

    // Custom column headers for the Excel file
    const headers = [
      "S.No",
      "Order Id",
      "BAP ID",
      "Created At",
      "Seller Name",
      "Order State",
      "Payment Status",
      "Item Count",
      "Order Total"
    ];

    // Prepare data matching the API response structure
    const data = orderList.map((order: any, index: any) => {
      let orderCreatedDate = order?.created_at
        ? moment(order.created_at).format("DD-MM-YYYY hh:mm:ss A")
        : "-";
      let sellerName = order?.name || order?.seller_name || order?.address?.start?.location?.descriptor?.name || "-";
      let orderState = order?.order_state || "-";
      let paymentStatus = order?.payment_status || order?.status || "-";
      let itemCount = order?.item_count !== undefined ? order.item_count : (order?.items ? (Array.isArray(order.items) ? order.items.length : 1) : 1);
      let orderTotal = order?.order_total !== undefined ? order.order_total : 0;

      return {
        "S.No": index + 1,
        "Order Id": order?.order_id || "-",
        "BAP ID": order?.bap_id || "-",
        "Created At": orderCreatedDate,
        "Seller Name": sellerName,
        "Order State": orderState,
        "Payment Status": paymentStatus,
        "Item Count": itemCount,
        "Order Total": orderTotal,
      };
    });


    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.json_to_sheet(data, { header: headers });


    ws["!cols"] = [
      { wch: 8 },  // S.No
      { wch: 16 }, // Order Id
      { wch: 24 }, // Created At
      { wch: 30 }, // Seller Name
      { wch: 18 }, // Order State
      { wch: 18 }, // Payment Status
      { wch: 14 }, // Item Count
      { wch: 14 }, // Order Total
    ];

    XLSX.utils.book_append_sheet(wb, ws, "Orders");

    const fileName = `allorders_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;

    XLSX.writeFile(wb, fileName);
    toast.success("Excel downloaded successfully!");
  };

  const [isExporting, setIsExporting] = useState(false);

  const handleExportExcel = async () => {
    try {
      setIsExporting(true);
      const token = sessionStorage.getItem("token");
      const res = await fetch(`${apiEndpoint}/snp/orders/export-orders?mode=summary`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(token ? { "Authorization": `Bearer ${token}` } : {}),
        },
        body: JSON.stringify({
          orderType: "active",
          order_id: valueid ? valueid.trim() : "",
          created_at: valuedate ? valuedate : "",
          payment_type: valuestatus ? valuestatus : "",
        }),
      });

      const contentType = res.headers.get("content-type") || "";
      if (contentType.includes("application/json")) {
        const data = await res.json();
        if (data?.status === false || data?.success === false || !res.ok) {
          toast.error(data?.message || "No orders found!");
          return;
        }

        if (data?.fileUrl || data?.url || data?.downloadUrl || data?.download_url) {
          const downloadLink = data.fileUrl || data.url || data.downloadUrl || data.download_url;
          window.open(downloadLink, "_blank");
          toast.success("Excel downloaded successfully!");
        } else if (data?.orders && Array.isArray(data.orders)) {
          if (data.orders.length === 0) {
            toast.error(data?.message || "No orders found!");
          } else {
            exportToExcel(data.orders);
          }
        } else if (data?.data && Array.isArray(data.data)) {
          if (data.data.length === 0) {
            toast.error(data?.message || "No orders found!");
          } else {
            exportToExcel(data.data);
          }
        } else if (Array.isArray(data)) {
          if (data.length === 0) {
            toast.error("No orders found!");
          } else {
            exportToExcel(data);
          }
        } else if (data?.message) {
          if (data?.status === true) {
            toast.success(data.message);
          } else {
            toast.error(data.message);
          }
        } else {
          toast.success("Excel downloaded successfully!");
        }
      } else {
        if (!res.ok) {
          throw new Error(`Export request failed with status: ${res.status}`);
        }
        const blob = await res.blob();
        const contentDisposition = res.headers.get("Content-Disposition") || res.headers.get("content-disposition");
        let filename = `active_orders_${moment().format("YYYYMMDD_HHmmss")}.xlsx`;
        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?([^"]+)"?/);
          if (match && match[1]) filename = match[1];
        }
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        toast.success("Excel downloaded successfully!");
      }
    } catch (error: any) {
      console.error("Export excel API error, falling back to local export:", error);
      try {
        let list = allorders && allorders.length > 0 ? allorders : null;
        if (!list || list.length === 0) {
          list = await exportorders();
        }
        if (!list || list.length === 0) {
          list = sellerList && sellerList.length > 0 ? sellerList : [];
        }
        exportToExcel(list);
      } catch (fallbackErr) {
        toast.error("Failed to export Excel. Please try again.");
      }
    } finally {
      setIsExporting(false);
    }
  };

  useEffect(() => {
    getSellerList();
    // exportorders();
  }, []);

  const [modalvisible, setModalvisible] = useState(false)
  const [showmessage, setShowmessage] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleCancel = () => {
    setModalvisible(false)
  }


  const handleFileChange = (e: any) => {
    setSelectedFile(e.target.files[0]);
  };

  // Upload file API
  const handleSubmit = async () => {
    if (!selectedFile) {
      toast.error("No file selected!");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const token = sessionStorage.getItem("token");
      const response = await axios.post(
        `${apiEndpoint}/import-order-status`,

        formData,
        {
          headers:
          {
            "Content-Type": "multipart/form-data",
            "x-custom-authorization": `Bearer ${token}`

          },
        }
      );

      toast.success("File uploaded successfully!");
      setSelectedFile(null);
      if (fileInputRef.current) fileInputRef.current.value = "";
      setModalvisible(false);
      console.log(response.data);
    } catch (err) {
      console.error(err);
      toast.error("Failed to upload file.");
    }
  };

  return (
    <>
      <style>{`
        .table-border.table-responsive {
          overflow-x: auto !important;
          -webkit-overflow-scrolling: touch;
        }
        .table-border .custom-table {
          width: 100% !important;
          border-collapse: separate !important;
          border-spacing: 0 !important;
        }
        .table-border .custom-table thead tr {
          background-color: #F97316 !important;
        }
        .table-border .custom-table th {
          background-color: #F97316 !important;
          color: #FFFFFF !important;
          font-weight: 700 !important;
          font-size: 13px !important;
          padding: 10px 14px !important;
          white-space: nowrap !important;
          border: none !important;
        }
        .table-border .custom-table th:first-child {
          border-top-left-radius: 14px !important;
        }
        .table-border .custom-table th:last-child {
          border-top-right-radius: 14px !important;
        }
        .table-border .custom-table td {
          padding: 10px 14px !important;
          font-size: 13px !important;
          border-bottom: 1px solid #F1F5F9 !important;
          vertical-align: middle !important;
          color: #334155 !important;
        }
        .table-border .custom-table tbody tr:nth-child(even) {
          background-color: #FFFBF7 !important;
        }
        .table-border .custom-table tbody tr:nth-child(odd) {
          background-color: #FFFFFF !important;
        }
        .table-border .custom-table tbody tr:hover {
          background-color: #FFF2E8 !important;
        }
      `}</style>
      <ThemeMaker>
        <div className="row w-100 m-0 mt-2">
          <div className="col-md-12">
            <div className="card shadow-sm border p-4 w-100 mb-4" style={{ borderRadius: "20px", borderColor: "#E5E7EB", backgroundColor: "#ffffff", boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)", position: "sticky", top: "10px", zIndex: 30 }}>
              {/* Header Title & Controls Row */}
              <div className="d-flex justify-content-between align-items-center flex-wrap mb-4" style={{ gap: "15px" }}>
                <h4 className="font-weight-bold m-0" style={{ color: "#0F172A", fontSize: "24px" }}>
                  Active Orders
                </h4>

                <div className="d-flex align-items-end flex-wrap" style={{ gap: "12px" }}>
                  {/* Search Order ID Fieldset */}
                  <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                    <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                      Search Order ID
                    </legend>
                    <div className="d-flex align-items-center" style={{ marginTop: "-6px" }}>
                      <i className="fas fa-search mr-2" style={{ fontSize: "13px", color: "#F97316" }}></i>
                      <input
                        type="search"
                        name="order_id"
                        placeholder="Search Order ID..."
                        className="border-0 bg-transparent text-dark"
                        onChange={handleOrderIdChange}
                        value={valueid ? valueid : ""}
                        style={{ outline: "none", fontSize: "14px", width: "170px" }}
                      />
                    </div>
                  </fieldset>

                  {/* Payment Status Filter Fieldset */}
                  <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                    <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                      Payment Status
                    </legend>
                    <div className="d-flex align-items-center" style={{ marginTop: "-6px" }}>
                      <select
                        name="payment_status"
                        onChange={handlePaymentStatusChange}
                        value={valuestatus || ""}
                        style={{
                          border: "none",
                          outline: "none",
                          width: "130px",
                          height: "26px",
                          background: "transparent",
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#334155",
                          cursor: "pointer"
                        }}
                      >
                        <option value="">All Status</option>
                        <option value="ON-ORDER">Prepaid</option>
                        <option value="ON-FULFILLMENT">COD</option>
                      </select>
                    </div>
                  </fieldset>

                  {/* Filter By Date Fieldset */}
                  <fieldset style={{ border: "1.5px solid #F97316", borderRadius: "10px", padding: "0 12px 6px 12px", margin: 0, height: "46px", backgroundColor: "#FFFFFF" }}>
                    <legend style={{ width: "auto", padding: "0 6px", fontSize: "11px", color: "#F97316", fontWeight: 600, margin: 0 }}>
                      Filter By Date
                    </legend>
                    <div className="d-flex align-items-center" style={{ marginTop: "-6px" }}>
                      <input
                        type="date"
                        name="date"
                        value={valuedate || ""}
                        onChange={handleDateChange}
                        style={{
                          border: "none",
                          outline: "none",
                          width: "135px",
                          height: "26px",
                          background: "transparent",
                          fontSize: "13px",
                          color: "#334155",
                          cursor: "pointer"
                        }}
                      />
                      {valuedate && (
                        <button
                          type="button"
                          onClick={handleClearDate}
                          title="Clear Date"
                          style={{
                            border: "none",
                            background: "#FEE2E2",
                            color: "#EF4444",
                            borderRadius: "50%",
                            width: "18px",
                            height: "18px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "11px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            marginLeft: "4px",
                            padding: 0
                          }}
                        >
                          ✕
                        </button>
                      )}
                    </div>
                  </fieldset>

                  <button
                    className="btn text-white font-weight-bold d-flex align-items-center justify-content-center"
                    style={{
                      backgroundColor: "#F97316",
                      borderColor: "#F97316",
                      borderRadius: "10px",
                      height: "40px",
                      padding: "0 18px",
                      fontSize: "13px",
                      boxShadow: "0 2px 6px rgba(249, 115, 22, 0.3)",
                      gap: "6px",
                      opacity: isExporting ? 0.7 : 1,
                      cursor: isExporting ? "not-allowed" : "pointer",
                      alignSelf: "flex-end"
                    }}
                    onClick={handleExportExcel}
                    disabled={isExporting}
                  >
                    {isExporting ? (
                      <>
                        <i className="fas fa-spinner fa-spin"></i> Exporting...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-file-excel"></i> Export Excel
                      </>
                    )}
                  </button>
                </div>
              </div>

              <div className="d-none">
                <input
                  type="search"
                  name="name"
                  onChange={(e) => {
                    seller?.read ? inputeHandler(e) : inputeeHandler(e);
                  }}
                  value={valuename ? valuename : ""}
                />
              </div>

              {/* Commented Order Status Update modal preserved */}
              {/* <div className="col-auto col-sm-auto col-md-3 mb-1 px-0 Drawer__modal">
                <Tag className="m-0 w-100"
                  style={{ cursor: "pointer", padding: "2px 3px", display: "inline-block" }}
                  onMouseEnter={() => setShowmessage(true)}
                  onMouseLeave={() => setShowmessage(false)}
                  onClick={() => setModalvisible(true)}
                >
                  Order Status Update
                </Tag>
                {showmessage && (
                  <div className="absolute top-full mt-1 left-1/2 -translate-x-1/2 bg-gray-700 text-white text-xs rounded px-2 py-1">
                    Update Via Csv
                  </div>
                )}
                <AntModal style={{ height: "300px !Important", borderRadius: "10px" }}
                  className="custom-left-modal"
                  open={modalvisible}
                  onCancel={handleCancel}
                  width={320}
                  mask={false}
                  footer={null}
                >
                  <div className="flex flex-col gap-4 text-center mt-4">
                    <input
                      type="file"
                      className="filter-tag"
                      accept=".csv"
                      ref={fileInputRef}
                      onChange={handleFileChange}
                    />
                    <Button className="btn btn-primary mt-3" type="primary" onClick={handleSubmit} disabled={!selectedFile}>
                      Submit
                    </Button>
                  </div>
                </AntModal>
              </div> */}

              {/* Table directly inside the same white card container */}
              {!isLoading ? (
                <div>
                  {sellerList && (
                    <>
                      <div className="table-border table-responsive w-100" style={{ borderRadius: "16px", border: "1px solid #E5E7EB", overflowX: "auto" }}>
                        <Paginated data={sellerList} columns={COLUMNS as any} />
                      </div>
                      <div className="hidediv mt-3">
                        {sellerList.map((item: any) => {
                          const isPaid = item.payment_type === "ON-ORDER" || item.status === "PAID" || item.payment_status === "PAID";
                          return (
                            <div className="border p-3 mb-2 bg-white" key={item?.order_id || Math.random()} style={{ borderRadius: "12px", boxShadow: "0 2px 6px rgba(0,0,0,0.04)" }}>
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <span style={{ fontWeight: 700, fontSize: "15px", color: "#0F172A" }}>Order #{item?.order_id}</span>
                                <span style={{ backgroundColor: "#DCFCE7", color: "#166534", padding: "2px 10px", borderRadius: "12px", fontSize: "12px", fontWeight: 700 }}>
                                  {(item?.order_state || "COMPLETED").toUpperCase()}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
                                <span className="text-muted">BAP ID:</span>
                                <span style={{ fontWeight: 600, color: "#475569" }}>{item?.bap_id || "-"}</span>
                              </div>
                              <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
                                <span className="text-muted">Customer Name:</span>
                                <span style={{ fontWeight: 600 }}>{item?.name || "Customer"}</span>
                              </div>
                              <div className="d-flex justify-content-between mb-1" style={{ fontSize: "13px" }}>
                                <span className="text-muted">Payment Status:</span>
                                <span style={{ fontWeight: 600, color: isPaid ? "#166534" : "#B45309" }}>
                                  {isPaid ? "PAID" : "COD / UNPAID"}
                                </span>
                              </div>
                              <div className="d-flex justify-content-between align-items-center mt-3">
                                <span style={{ fontWeight: 700, color: "#F97316", fontSize: "16px" }}>₹{item?.order_total || 0}</span>
                                <Link to={`/orderCompleteDetail/${item.order_id}`} style={{ textDecoration: "none" }}>
                                  <button className="btn btn-sm text-white font-weight-bold" style={{ backgroundColor: "#F97316", border: "none", borderRadius: "8px", padding: "6px 14px" }}>
                                    Get Order Details
                                  </button>
                                </Link>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                  <CircularProgress style={{ color: "#F97316" }} />
                </div>
              )}
            </div>
          </div>
        </div>
      </ThemeMaker>
    </>
  );
};

export default customerOrder;